import { api } from "../http";
import type { NotificationRecord, Page } from "../types";

const BASE_PATH = "/api/notifications";

const buildQuery = (params: Record<string, unknown>) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&");

export const notificationsApi = {
  list(params: { page?: number; size?: number } = {}) {
    const query = buildQuery(params);
    const path = query ? `${BASE_PATH}?${query}` : BASE_PATH;
    return api.get<Page<NotificationRecord>>(path);
  },
  markAsRead(id: string) {
    return api.post<NotificationRecord, void>(`${BASE_PATH}/${encodeURIComponent(id)}/read`);
  },
  markAllAsRead() {
    return api.post<void, void>(`${BASE_PATH}/mark-all-read`);
  },
};
